/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* utilities */
import { parseDataToProps } from '~/utilities';

const searchNodes = Array.from(document.querySelectorAll('[data-instant-search]'));

[...searchNodes].forEach((node) => {
    import(/* webpackChunkName: "Search" */ './components/Search').then(({ default: Search }) => {
        render(<Search {...parseDataToProps(node.dataset)} />, node);
    });
});

